export const DEFAULT_LOCALE = 'en-US';
export const STRINGS_MESSAGE_BUNDLE_NAME = 'strings';
